import React from 'react';

import { URL_IMAGES_I } from 'constants/UrlConstants';

const Mastercard = ({ data }) => {
    return (
        <div className="section-mastercard no-spinner" id="section-mastercard-promo">
            <div data-modal-id="mastercard-promo-block" className="box-1280 js_show-prepared-promo-modal_initialized">
                <div className="inner-content">
                    <div className="lead-text max-620">
                        {data?.title && <h2 className="title1">{data.title}</h2>}
                        <div className="maincopy color-medium-gray">
                            <p>{data.info}</p>
                        </div>
                    </div>
                    <figure className="illustration top text-center">
                        <picture>
                            <source
                                media="(min-width: 1352px)"
                                srcSet={`${URL_IMAGES_I}/promo-mastercard-c.png 1x, ${URL_IMAGES_I}/promo-mastercard-c@2x.png 2x`}
                            />
                            <img src={`${URL_IMAGES_I}/promo-mastercard-c.png`} alt=" " />
                        </picture>
                    </figure>
                    {data?.listItems && (
                        <ol className="maincopy">
                            {data.listItems.map((item) => {
                                return (
                                    <li key={item}>
                                        <div className="inner-content color-medium-gray">
                                            <p>{item}</p>
                                        </div>
                                    </li>
                                );
                            })}
                        </ol>
                    )}

                    <div className="show-all__block">
                        {data?.links &&
                            data.links.map((link) => {
                                return (
                                    <p key={link.name}>
                                        <a className="link-next" target="_blank" href={link.url}>
                                            <span className="color-GT">{link.name}</span>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="svg-icon-shevron-right"
                                                height="24"
                                                width="24"
                                                viewBox="0 0 24 24"
                                                version="1.1"
                                            >
                                                <path
                                                    d="M9.5,17.5l5-5l-5-5"
                                                    strokeLinejoin="round"
                                                    strokeLinecap="round"
                                                    strokeWidth="1.6"
                                                    stroke="#7633ff"
                                                    fill="none"
                                                ></path>
                                            </svg>
                                        </a>
                                    </p>
                                );
                            })}
                    </div>
                    <figure className="illustration bottom text-center">
                        <picture>
                            <source
                                media="(min-width: 648px)"
                                srcSet={`${URL_IMAGES_I}/promo-mastercard-b.png 1x, ${URL_IMAGES_I}/promo-mastercard-b@2x.png 2x`}
                            />
                            <source srcSet={`${URL_IMAGES_I}/promo-mastercard-a.png 1x, ${URL_IMAGES_I}/promo-mastercard-a@2x.png 2x`} />
                            <img alt="Illustration" src={`${URL_IMAGES_I}/promo-mastercard-b.png`} />
                        </picture>
                    </figure>
                </div>
            </div>
        </div>
    );
};

export default Mastercard;
